import { useState } from 'react';

import StorybookImg from './storybook.png';

const StorybookLink = () => {
  const [show, setShow] = useState(true);
  return show ? (
    <div>
      <div className='relative'>
        <div className='-right-1 absolute top-[-4px] flex size-4 items-center justify-center rounded-full border bg-white text-[10px]' onClick={() => setShow(false)}>
          X
        </div>
        <a href='https://master--669e3d3d87a94caa8f567a9b.chromatic.com/' target='_blank' rel='noreferrer noopener'>
          <img src={StorybookImg} width='24' height='24' />
        </a>
      </div>
    </div>
  ) : null;
};

export default StorybookLink;
